export function findUsedLabelsAndCategories(text) {
    let labelsID = new Set();
    let categoriesID = new Set();
    Array.isArray(text.lines) && text.lines.forEach((line) => {
        Array.isArray(line.tokens) && line.tokens.forEach((token) => {
            Array.isArray(token.labels) && token.labels.forEach((label) => {
                let isIn = labelsID.has(label.id);
                if (!isIn) // add if not in list
                    labelsID.add(label.id);
                isIn = categoriesID.has(label.collection.id);
                if (!isIn) // add if not in list
                    categoriesID.add(label.collection.id);
            });
        });
    });
    return {
        // table of labels IDs
        labelsID,
        // table of label set IDs
        categoriesID
    };
}

// replaces incomplete labels in the text
export function replaceLabelsInText(txt, labels) {
    Array.isArray(txt.lines) && txt.lines.forEach((line) => {
        Array.isArray(line.tokens) && line.tokens.forEach((token) => {
            let tokenLabels = [];
            Array.isArray(token.labels) && token.labels.forEach((label) => {
                let found = labels.find(ul => ul.id === label.id);
                if (found) // add if not in list
                    tokenLabels.push(found);
            });
            token.labels = tokenLabels;
        });
    });
}